import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectionExternalAssetSettings, useUpdateProjectionExternalAssetItemSetting, useUpdateProjectionExternalAssetSetting } from '../../api';
import { useTotalSelectedBankableAssets } from '../exporter/scenarios/hooks';
import { SettingBoxBase, SettingBoxPositionTable } from '../settings-drawer';

export const AssetWithOtherBanksSettings: FunctionComponent = () => {
    const { t } = useTranslation();
    const totalSelectedBankableAssets = useTotalSelectedBankableAssets();
    const { data: externalAssetsSettings } = useProjectionExternalAssetSettings();

    const updateExternalAssetsSettings = useUpdateProjectionExternalAssetSetting();
    const updateExternalAssetsItemSettings = useUpdateProjectionExternalAssetItemSetting();

    return (
        <SettingBoxBase
            title={t('assetsWithOtherBanks')}
            showWarningIcon={totalSelectedBankableAssets <= 0}
            warningText={t('noBankableAssetsWarning')}
            boxId={externalAssetsSettings?.id}
            toggled={externalAssetsSettings?.enabled}
            onToggle={updateExternalAssetsSettings}
            detail={
                <SettingBoxPositionTable
                    enabled={!!externalAssetsSettings?.enabled}
                    updateItemSettings={updateExternalAssetsItemSettings}
                    itemSettings={externalAssetsSettings?.itemsSettings ?? []}
                    totalAmount={externalAssetsSettings?.totalAmount ?? 0}
                    emptyStateMessage={t('settingsDrawerEmpty.assetsWithOtherBanks')}
                    emptyStateShowWealthLink={true}
                />
            }
        />
    );
};
